module.exports = __webpack_public_path__ + "img/1729129957678-IMG_4652.jpeg.bbb39b48.webp";